<template>
  <div class="match-block">
    <font-awesome-icon :icon="['fas','square-full']" size="xs"/>
    <font-awesome-icon :icon="['fas','square-full']" size="xs"/>
    <font-awesome-icon :icon="['fas','square-full']" class="has-text-danger" size="xs"/>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquareFull } from '@fortawesome/pro-solid-svg-icons';

library.add(faSquareFull);

export default {
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .match-block
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
    // padding: 1rem
    color: #eee
    & > *
      margin-bottom: .25rem
    &:last-child
      margin-bottom: none
  .is-warning
    color: #ffc107
</style>
